/** Embed snippets for an organisation's key (iframe, script loader, WordPress). The snippets are code: never
 * translated. */
import { publicApiOrigin } from "../config";
import type { Translate } from "../i18n/I18nProvider";
import { translateOutside } from "../i18n/problems";

/** The hosted calculator page for a key. The API serves it with `frame-ancestors` = the key's allowed origins (plus
 * localhost for test keys), so it only shows framed on those sites. No Google key is needed. */
export function widgetSrc(key: string): string {
  return `${publicApiOrigin()}/api/public/embed/${encodeURIComponent(key)}`;
}

export function iframeSnippet(key: string): string {
  return [
    `<iframe src="${widgetSrc(key)}"`,
    `        style="width:100%;height:1100px;border:0" loading="lazy" title="Solar quote"></iframe>`,
  ].join("\n");
}

export const wordpressShortcode = "[solar_quote_pro]";
export const wordpressModalShortcode = '[solar_quote_pro modal="1"]';

/** `https://www.example.com/path` → `https://www.example.com`; bare domains get https. */
export function normalizeOrigin(raw: string): string {
  let value = raw.trim().toLowerCase();
  if (!value) return "";
  if (!/^https?:\/\//.test(value)) value = `https://${value}`;
  const match = value.match(/^(https?:\/\/(\*\.)?[^/?#]+)/);
  return match ? match[1] : value;
}

const ORIGIN = /^https?:\/\/(\*\.)?[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*(:[0-9]{1,5})?$/;
/** What is wrong with a typed website address (null when it is fine), in the reader's language: pass `t` from a
 * component; without it the provider's registered language is used. */
export function originProblem(origin: string, t?: Translate): string | null {
  if (ORIGIN.test(origin)) return null;
  const values = { origin, example: "https://www.example.com" };
  return t ? t("website.origins.invalid", values) : (translateOutside("website.origins.invalid", values) ?? origin);
}
